<template>
  <!-- 左侧边栏-->
  <el-aside :class="['app-sidebar', { collapsed: isCollapse }]" v-show="sidebarShow">
    <!-- 头部 LOGO -->
    <router-link class="logo-wrapper" to="/home">
      <img
        src="@/assets/img/game-logo.png"
        class="logo-img"
        alt="Logo"
      />
      <div class="logo-text-box" v-if="!isCollapse">
        <div class="logo-main-title">Channel Admin</div>
        <div class="logo-sub-title">游戏渠道管理后台</div>
      </div>
    </router-link>

    <!-- 菜单 -->
    <div class="menu-scroll-container">
      <el-menu
        :background-color="menuBg"
        :text-color="menuTextColor"
        :active-text-color="menuActiveTextColor"
        :router="true"
        :collapse="isCollapse"
        :collapse-transition="false"
        :unique-opened="false"
        :default-active="activeMenu"
        :default-openeds="defaultOpeneds"
        class="left-menu-vertical"
      >
        <template v-for="group in menuGroups">
          <!-- 如果有子菜单，渲染为二级折叠菜单 -->
          <el-submenu
            v-if="group.items && group.items.length > 0"
            :key="group.id"
            :index="group.id"
            class="sidebar-submenu"
          >
            <template slot="title">
              <font-awesome-icon :icon="group.icon" class="sidebar-icon" />
              <span class="sidebar-menu-text">{{ group.title }}</span>
            </template>

            <el-menu-item
              v-for="item in group.items"
              :key="item.path"
              :index="item.path"
              class="sidebar-menu-item sub-item"
            >
              <font-awesome-icon :icon="item.icon" class="sidebar-icon sub-icon" />
              <span slot="title" class="sidebar-menu-text">{{ item.name }}</span>
            </el-menu-item>
          </el-submenu>

          <!-- 如果没有子菜单，渲染为一级独立菜单 -->
          <el-menu-item
            v-else
            :key="group.id"
            :index="group.path"
            class="sidebar-menu-item single-item"
          >
            <font-awesome-icon :icon="group.icon" class="sidebar-icon" />
            <span slot="title" class="sidebar-menu-text">{{ group.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>

    <!-- 折叠收缩侧栏按钮 -->
    <div class="sidebar-collapse-trigger" @click="toggleSidebarCollapse">
      <i :class="isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'" class="collapse-icon"></i>
      <span v-if="!isCollapse" class="collapse-text">收起侧边栏</span>
    </div>
  </el-aside>
</template>

<script>
export default {
  name: 'AltSidebar',
  data () {
    return {
      defaultOpeneds: ['channel-access', 'login-pay', 'merchant'],
      menuGroups: [
        {
          id: 'product-manage',
          title: '游戏管理',
          path: '/p',
          icon: 'project-diagram',
          items: []
        },
        {
          id: 'channel-access',
          title: '渠道接入',
          icon: 'plug',
          items: [
            { name: '渠道列表', path: '/c/cl', icon: 'plug' },
            { name: '平台规划', path: '/pl', icon: 'sliders-h' },
            { name: '渠道类型', path: '/ct', icon: 'tags' },
            { name: 'Visitor逻辑', path: '/l', icon: 'microchip' },
            { name: '同步参数', path: '/n', icon: 'sync' },
            { name: '重载NACOS', path: '/nacos', icon: 'sync-alt' }
          ]
        },
        {
          id: 'login-pay',
          title: '登录支付',
          icon: 'coins',
          items: [
            { name: 'XS游戏', path: '/xs/args/game', icon: 'gamepad' },
            { name: 'XS渠道', path: '/xs/args/channel', icon: 'link' },
            { name: 'XS逻辑', path: '/xs/args/logic', icon: 'cog' },
            { name: '支付Agrs', path: '/xs/args/pay', icon: 'coins' },
            { name: '电信认证', path: '/xs/telecom/auth', icon: 'mobile-alt' }
          ]
        },
        {
          id: 'merchant',
          title: '商户配置',
          icon: 'layer-group',
          items: [
            { name: '商户组', path: '/mch/group', icon: 'layer-group' },
            { name: '微信商户', path: '/mch/wx', icon: 'comments' },
            { name: '支付宝商户', path: '/mch/ali', icon: ['fab', 'alipay'] },
            { name: 'Apple应用', path: '/mch/apple', icon: ['fab', 'apple'] }
          ]
        },
        {
          id: 'ext-config',
          title: '扩展配置',
          icon: 'puzzle-piece',
          items: [
            { name: 'Ext游戏', path: '/ext/config/game', icon: 'puzzle-piece' },
            { name: 'Ext渠道', path: '/ext/config/channel', icon: 'link' },
            { name: 'Ext模版', path: '/ext/config/template', icon: 'cubes' }
          ]
        },
        {
          id: 'env-config',
          title: '环境配置',
          icon: 'network-wired',
          items: [
            { name: '节假日', path: '/holiday', icon: 'calendar-alt' },
            { name: '卸载菜单', path: '/menu', icon: 'list-ul' },
            { name: '网关域名', path: '/area', icon: 'network-wired' },
            { name: 'UFO分组', path: '/ufo/group', icon: 'layer-group' },
            { name: '证书配置', path: '/pkg', icon: 'certificate' }
          ]
        },
        {
          id: 'risk-list',
          title: 'UFW',
          icon: 'passport',
          items: [
            { name: '节点内存', path: '/ufw', icon: 'memory' },
            { name: '白名单', path: '/ufw/white', icon: 'passport' },
            { name: '黑名单', path: '/ufw/black', icon: 'passport' }
          ]
        },
        {
          id: 'ad-monetization',
          title: '广告变现',
          icon: 'ad',
          items: [
            { name: '广告应用', path: '/advert/app', icon: 'ad' },
            { name: '广告渠道', path: '/advert/channel', icon: 'yen-sign' }
          ]
        },
        {
          id: 'company-entity',
          title: '公司主体',
          icon: 'building',
          items: [
            { name: '公司管理', path: '/company', icon: 'building' },
            { name: '组织管理', path: '/organize', icon: 'users' }
          ]
        },
        {
          id: 'others',
          title: '其他',
          icon: 'folder',
          items: [
            { name: '应用分配', path: '/wiki/app', icon: 'cube' },
            { name: 'VPC规划', path: '/wiki/vpc', icon: 'network-wired' }
          ]
        }
      ]
    }
  },
  computed: {
    device () {
      return this.$store.getters.device
    },
    sidebar () {
      return this.$store.getters.sidebar
    },
    isMobile () {
      return this.device === 'mobile'
    },
    isCollapse () {
      return !this.sidebar.opened
    },
    sidebarShow () {
      return !this.isMobile || this.sidebar.opened
    },
    activeMenu () {
      const route = this.$route
      const { path } = route
      if (path.startsWith('/c/detail')) return '/c/cl'
      return path
    },
    isDark () {
      return this.$store.getters.theme === 'dark'
    },
    menuBg () {
      return this.isDark ? '#1e293b' : '#ffffff'
    },
    menuTextColor () {
      return this.isDark ? '#94a3b8' : '#64748b'
    },
    menuActiveTextColor () {
      return this.isDark ? '#3b82f6' : '#2563eb'
    }
  },
  methods: {
    toggleSidebarCollapse () {
      this.$store.dispatch('ToggleSideBar')
    }
  }
}
</script>

<style scoped>
.app-sidebar {
  background-color: var(--bg-sidebar);
  color: var(--text-muted);
  width: 220px !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--border-color);
  transition: width 0.3s cubic-bezier(0.2, 0, 0, 1) !important;
  z-index: 1001;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  overflow-x: hidden !important; /* 彻底拦截收缩溢出导致的水平滚动条 */
  user-select: none !important;
}

.app-sidebar.collapsed {
  width: 56px !important;
  overflow-x: hidden !important; /* 彻底拦截收缩溢出导致的水平滚动条 */
}

/* Logo 样式 */
.logo-wrapper {
  height: 56px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  text-decoration: none;
  background-color: var(--bg-sidebar);
  border-bottom: 1px solid var(--border-color);
  overflow: hidden;
  flex-shrink: 0;
}
.logo-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
  transition: background-color 0.2s ease;
}

html.dark .logo-img {
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 6px;
  padding: 2px;
  box-sizing: border-box;
}

.logo-text-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 12px;
  line-height: 1.25;
}

.logo-main-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-main);
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.logo-sub-title {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-muted);
  margin-top: 2px;
  white-space: nowrap;
}

.app-sidebar.collapsed .logo-wrapper {
  padding: 0;
  justify-content: center;
}

/* 滚动区域 */
.menu-scroll-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden !important;
}

.menu-scroll-container::-webkit-scrollbar {
  width: 4px;
}
.menu-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}
.menu-scroll-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
}

.left-menu-vertical {
  border: none !important;
  width: 100% !important;
  user-select: none !important;
}

/* 菜单项/子菜单标题定制 */
.sidebar-menu-item {
  height: 40px !important;
  line-height: 40px !important;
  margin: 4px 12px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  transition: all 0.2s ease !important;
  color: var(--text-muted) !important;
}

.sidebar-icon {
  margin-right: 12px;
  font-size: 14px;
  width: 16px;
  text-align: center;
  color: var(--text-muted);
  transition: transform 0.2s ease;
}

.sidebar-menu-item:hover {
  background-color: rgba(37, 99, 235, 0.04) !important;
  color: var(--text-main) !important;
}

.sidebar-menu-item:hover .sidebar-icon {
  color: var(--text-main);
  transform: scale(1.1);
}

.sidebar-menu-item.is-active {
  background-color: rgba(37, 99, 235, 0.08) !important;
  color: var(--primary-color) !important;
  position: relative;
  font-weight: 600;
}

.sidebar-menu-item.is-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
  height: 20px;
  width: 3px;
  background-color: var(--primary-color);
  border-radius: 0 4px 4px 0;
}

.sidebar-menu-item.is-active .sidebar-icon {
  color: var(--primary-color) !important;
}

/* 菜单文字的平滑过渡，消除宽度渐变时换行被挤压而产生的跳动 */
.sidebar-menu-text {
  font-weight: 500;
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  opacity: 1;
  display: inline-block;
  white-space: nowrap;
  max-width: 150px;
  vertical-align: middle;
}

.collapsed .sidebar-menu-text {
  opacity: 0 !important;
  max-width: 0 !important;
  overflow: hidden;
  pointer-events: none;
}

/* 二级折叠菜单标题样式 */
:deep(.el-submenu__title) {
  height: 40px !important;
  line-height: 40px !important;
  margin: 4px 12px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  transition: all 0.2s ease !important;
  color: var(--text-muted) !important;
}

:deep(.el-submenu__title:hover) {
  background-color: rgba(37, 99, 235, 0.04) !important;
  color: var(--text-main) !important;
}

:deep(.el-submenu__title .sidebar-icon) {
  margin-right: 12px;
  font-size: 14px;
  width: 16px;
  text-align: center;
  color: var(--text-muted);
  transition: transform 0.2s ease;
}

:deep(.el-submenu__title:hover .sidebar-icon) {
  color: var(--text-main);
  transform: scale(1.1);
}

/* 子菜单展开状态下的垂直连接线样式 */
:deep(.el-menu--inline) {
  background-color: transparent !important;
  border-left: 1.5px solid var(--border-color) !important;
  margin-left: 40px !important;
  padding-left: 2px !important;
  margin-top: 2px;
  margin-bottom: 2px;
  transition: all 0.2s ease;
}

/* 二级子菜单项样式 */
.sidebar-menu-item.sub-item {
  margin: 2px 12px 2px 0 !important;
  padding-left: 12px !important;
  height: 36px !important;
  line-height: 36px !important;
  font-size: 12.5px !important;
}

/* 折叠收缩侧栏按钮样式 */
.sidebar-collapse-trigger {
  height: 48px;
  line-height: 48px;
  border-top: 1px solid var(--border-color);
  padding: 0 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: var(--text-muted);
  transition: background-color 0.2s ease, color 0.2s ease;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.5px;
  background-color: var(--bg-sidebar);
  user-select: none;
  flex-shrink: 0;
}

.sidebar-collapse-trigger:hover {
  background-color: rgba(37, 99, 235, 0.04);
  color: var(--text-main);
}

.collapsed .sidebar-collapse-trigger {
  padding: 0 !important;
  width: 56px !important;
  justify-content: center !important;
}

.collapse-icon {
  font-size: 15px;
  -webkit-text-stroke: 0.4px currentColor;
  margin-right: 8px;
}

.collapsed .collapse-icon {
  margin-right: 0;
  font-size: 15px;
}

.collapse-text {
  white-space: nowrap;
  display: inline-block;
}

/* ==========================================================================
   强力覆盖折叠模式下的 element-ui 默认定位，解决一级独立导航偏右或错位问题
   ========================================================================== */
.left-menu-vertical.el-menu--collapse {
  width: 56px !important;
}

/* 强制让折叠下的 el-menu-item 容器完全居中，左右 margin 置为 0 */
.left-menu-vertical.el-menu--collapse :deep(.el-menu-item) {
  padding: 0 !important;
  margin: 4px 0 !important;
  width: 56px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 强制让折叠下的 el-submenu 标题容器完全居中，左右 margin 置为 0 */
.left-menu-vertical.el-menu--collapse :deep(.el-submenu__title) {
  padding: 0 !important;
  margin: 4px 0 !important;
  width: 56px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 强制将折叠下的图标外边距归零，实现完美的 56px 视口垂直水平居中 */
.left-menu-vertical.el-menu--collapse :deep(.sidebar-icon) {
  margin: 0 !important;
  font-size: 16px !important;
  width: 16px !important;
  text-align: center !important;
}

.left-menu-vertical.el-menu--collapse :deep(.el-submenu__icon-arrow) {
  display: none !important;
}
</style>
